import { benefitsPage } from '@constants/images';
import Cookies from 'js-cookie';

export const getAccessToken = () => {
  return Cookies.get('ca_token');
};

export const getUserId = () => {
  return Cookies.get('uuid_dp');
};

export function convertStringToDate(dateString: string | null) {
  if (dateString === null || undefined) {
    return new Date();
  }
  const [day, month, year] = dateString.split('-').map(Number); // Split and convert to numbers
  return new Date(year, month - 1, day); // Month is zero-based
}

export const getPointsByTier = (tier: string): number => {
  switch (tier) {
    case 'platinum':
      return 6;
    case 'gold':
      return 5;
    case 'silver':
      return 4;
    case 'bronze1':
      return 3;
    case 'bronze2':
      return 2;
    default:
      return 0;
  }
};

export const benefitsData = (tier: string) => {
  const formatTierName = (tierData: string) => {
    return tierData.charAt(0).toUpperCase() + tier.slice(1).toLowerCase();
  };

  const formattedTier = formatTierName(tier);
  type TierData = {
    discountPercentage: number;
    greenCard: number;
    tradeAdv: number;
    ltvPercent: number;
    budget: number;
    incentive: number;
    tickets: number;
    nights: number;
  };

  const tierData: Record<string, TierData> = {
    platinum: {
      discountPercentage: 3,
      greenCard: 4,
      tradeAdv: 45,
      ltvPercent: 10,
      budget: 8000,
      incentive: 6,
      tickets: 2,
      nights: 5,
    },
    gold: {
      discountPercentage: 2,
      greenCard: 2,
      tradeAdv: 45,
      ltvPercent: 8,
      budget: 5000,
      incentive: 5,
      tickets: 2,
      nights: 4,
    },
    silver: {
      discountPercentage: 1,
      greenCard: 0,
      tradeAdv: 30,
      ltvPercent: 5,
      budget: 3000,
      incentive: 4,
      tickets: 1,
      nights: 4,
    },
    bronze1: {
      discountPercentage: 1,
      greenCard: 0,
      tradeAdv: 30,
      ltvPercent: 3,
      budget: 0,
      incentive: 3,
      tickets: 1,
      nights: 4,
    },
    bronze2: {
      discountPercentage: 1,
      greenCard: 0,
      tradeAdv: 30,
      ltvPercent: 3,
      budget: 0,
      incentive: 2,
      tickets: 1,
      nights: 3,
    },
  };

  const defaultData = {
    discountPercentage: 0,
    greenCard: 0,
    tradeAdv: 30,
    ltvPercent: 0,
    budget: 0,
    incentive: 0,
    tickets: 1,
    nights: 3,
  };

  const tierValues = tierData[tier] || defaultData;

  const {
    discountPercentage,
    greenCard,
    tradeAdv,
    ltvPercent,
    // incentive,
    tickets,
    nights,
  } = tierValues;

  const cardData = [
    {
      id: 'discounted-pricing',
      logo: benefitsPage.card.discount,
      logoActive: benefitsPage.card.discountActive,
      bannerLogo: benefitsPage.banner.discountBanner,
      header: 'Discounted Pricing',
      desc: `You are getting ${discountPercentage}% lower rates compared to the Market Standards`,
      active: false,
      text: `Your customers will get Loans at a lower rate of interest compared to the Market Rate. As a “${formattedTier}” dealer, you are getting ${discountPercentage}% lower rates compared to the Market Standards!!!`,
    },
    {
      id: 'priority-disbursal',
      logo: benefitsPage.card.priority,
      logoActive: benefitsPage.card.priorityActive,
      bannerLogo: benefitsPage.banner.priorityBanner,
      header: 'Priority Disbursal',
      desc: 'As a VPP dealer, your Case will be disbursed at priority.',
      active: false,
      text: `As a “${formattedTier}” Dealer, you will be entitled with the highest priority disbursement over the queue.The cases will be allocated at first in the operations queue for disbursement`,
    },
    {
      id: 'trade-advance',
      logo: benefitsPage.card.trade,
      logoActive: benefitsPage.card.tradeActive,
      bannerLogo: benefitsPage.banner.tradeBanner,
      header: 'Trade Advance',
      desc: `As a ${formattedTier} dealer, you are eligible for ${tradeAdv} days – Interest Free TA!`,
      active: false,
      text: `Trade Advance or a short term credit facility will be provided with an Interest Free period of 30 days or 45 days to the Dealers.As a ${formattedTier} dealer, you are eligible for ${tradeAdv} days – Interest Free TA!!!`,
    },
    {
      id: 'customized-policy-support',
      logo: benefitsPage.card.customized,
      logoActive: benefitsPage.card.customizedActive,
      bannerLogo: benefitsPage.banner.customizedBanner,
      header: 'Customized Policy Support (N=1)',
      desc: `You can avail the below Policy deviations. – Tenure Deviation / LTV Deviation / Pin Code Deviation`,
      active: false,
      text: 'Credit Policy deviations will be given to the dealers on a case to case basis, based on the requirement of the dealer. You can avail the below Policy deviations. - Tenure Deviation / LTV Deviation / Pin Code Deviation',
    },
    {
      id: 'green-cards',
      logo: benefitsPage.card.check,
      logoActive: benefitsPage.card.checkActive,
      bannerLogo: benefitsPage.banner.checkBanner,
      header: 'Green Cards',
      desc: 'Approve cases rejected by LTF. Not applicable on policy reject cases',
      active: false,
      text: `This facility will allow dealers to disburse a loan to a customer even if the loan was non-policy reject case. This is subject to few conditions. As a “${formattedTier}” Dealer you are eligible for a maximum ${greenCard} green cards. **Green card will not be applicable for policy reject and dedupe reject cases **No carry forward of this benefit if not utilized`,
      hideOnTier: ['silver', 'bronze1', 'bronze2'],
    },
    {
      id: 'additional-ltv',
      logo: benefitsPage.card.addLTV,
      logoActive: benefitsPage.card.addLTVActive,
      bannerLogo: benefitsPage.banner.addLTVBanner,
      header: 'Additional LTV',
      desc: `As a “${formattedTier}” dealer, you are getting for ${ltvPercent}% higher LTV!`,
      active: false,
      text: `Your customers will get a higher LTV as a part of the
program in line with the prescribed policy parameters (upto ${ltvPercent}%
LTV). As ${formattedTier} dealer you will be getting ${ltvPercent}% higher LTV than
the approved LTV`,
    },
    {
      id: 'dedicated-virtual-relationship-manager',
      logo: benefitsPage.card.dvrm,
      logoActive: benefitsPage.card.dvrmActive,
      bannerLogo: benefitsPage.banner.dvrmBanner,
      header: 'Dedicated Virtual Relationship Manager',
      desc: `Connect with your Virtual Relationship Manager who is
dedicated to resolve all your queries`,
      active: false,
      text: ` Dedicated Relationship Manager from LTF to cater
to any queries or issues of the dealer. “${formattedTier}” dealer will be
able to connect with the VRM chat facility on the Application
`,
    },
    {
      id: 'personal-loan',
      logo: benefitsPage.card.personalLoan,
      logoActive: benefitsPage.card.personalLoanActive,
      bannerLogo: benefitsPage.banner.personalLoanBanner,
      header: 'Personal Loan for Eligible Dealer Employee',
      desc: `You can now avail Personal Loan with discounted ROI!`,
      active: false,
      text: `You will eligible to apply for personal loan for dealer
employees
`,
      hideOnTier: ['silver', 'bronze1', 'bronze2'],
    },
    {
      id: 'group-medical-insurance',
      logo: benefitsPage.card.grpMedical,
      logoActive: benefitsPage.card.grpMedicalActive,
      bannerLogo: benefitsPage.banner.grpMedicalBanner,
      header: 'Group Medical Insurance for dealer employee',
      desc: `You can now avail Group Medical Insurance for your
employee at a discounted rate!`,
      active: false,
      text: `LTF will be providing Medical Insurance at a
discounted rate for interested dealer employees
`,
    },
    /* {
      id: 'cash-incentive',
      logo: benefitsPage.card.cash,
      logoActive: benefitsPage.card.cashActive,
      bannerLogo: benefitsPage.banner.cashBanner,
      header: 'Cash Incentive per case',
      desc: `For every disbursal you earn Rs. ${incentive} as incentive which
will be paid at the Financial Year end on achieving your annual
target!`,
      active: false,
      text: ``,
    }, */
    {
      id: 'big-wheelz-trip-tickets',
      logo: benefitsPage.card.bwTickets,
      logoActive: benefitsPage.card.bwTicketsActive,
      bannerLogo: benefitsPage.banner.bwTicketsBanner,
      header: 'Big Wheelz Trip - No of tickets',
      desc: `You will be eligible for the international Big Wheelz trip
for ${tickets} tickets on achieving your annual target!`,
      active: false,
      text: ``,
    },
    {
      id: 'big-wheelz-trip-duration',
      logo: benefitsPage.card.bwDuration,
      logoActive: benefitsPage.card.bwDurationActive,
      bannerLogo: benefitsPage.banner.bwDurationBanner,
      header: 'Big Wheelz Trip - Duration (no of nights)',
      desc: `You will be eligible for the international Big Wheelz trip
for ${nights} no of nights, on achieving your annual target!
`,
      active: false,
      text: `“${formattedTier}” Dealer will be eligible for the international
Big Wheelz trip for ${nights} no of nights, on achieving your annual
target!!!`,
    },
  ];

  const data = cardData.filter((item: any) => {
    if (item?.hideOnTier && item.hideOnTier.includes(tier)) {
      return false;
    } else {
      return true;
    }
  });
  return data;
};
